// removed by extract-text-webpack-plugin
module.exports = {"page-sizer":"page-sizer__1-10s","page-select":"page-select__1lrPW"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageSizer/styles/main.scss
// module id = 2139
// module chunks = 1